export default "__VITE_ASSET__Bve5dd5m__"